import React from "react";
import { Box, Heading, Text, Stack } from "@chakra-ui/react";

const TermsAndConditions: React.FC = () => {
  return (
    <Box>
      <Stack gap={6}>
        <Heading as="h2" size="lg" color="gray.800" mb={4}>
          Cashquin Website and Payment Services Terms & Conditions
        </Heading>

        <Text color="gray.600" lineHeight="1.6">
          By accessing and using this website and the Cashquin services provided
          herein, you agree to the following terms and conditions.
        </Text>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Use of Service
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Provide accurate information for every transaction.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Do not share OTPs or passwords with anyone.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Transactions are subject to bank, gateway, and Cashquin
              availability.
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Payments & Charges
          </Heading>
          <Stack gap={2}>
            <Text color="gray.600" lineHeight="1.6">
              • Charges, if any, will be shown before you confirm payment.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              • Taxes are applied as per applicable laws.
            </Text>
            <Text color="gray.600" lineHeight="1.6">
              {`• Successful payment does not guarantee service by the biller;
              service fulfillment is the biller's responsibility.`}
            </Text>
          </Stack>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Refunds & Cancellations
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            Refer to the Refunds & Cancellations policy for details. Refunds are
            subject to biller and bank rules, and may take 5–7 working days
            after approval.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Liability Limitations
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            We are not liable for delays, interruptions, or failures caused by
            third-party systems (banks, billers, networks). Indirect or
            consequential damages are excluded to the extent permitted by law.
          </Text>
        </Box>

        <Box>
          <Heading as="h3" size="md" color="gray.800" mb={3}>
            Compliance & Conduct
          </Heading>
          <Text color="gray.600" lineHeight="1.6">
            You agree to comply with applicable laws and Cashquin guidelines. Misuse
            of the platform may result in suspension of access.
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};

export default TermsAndConditions;
